/**
 * @file LegalProfileNotice.tsx
 * @description Полоса «реквизиты продавца не заполнены» (phase19.31, часть 3;
 * контракт §19) над реестром документов и в карточке документа.
 *
 * Показывается по признаку сервера `legalProfileIncomplete`; чего именно не
 * хватает — словами из `legalProfileGaps` («Не указаны: ИНН, расчётный
 * счёт»). Объясняет, что выйдет в документе, и ведёт в «Настройки →
 * Реквизиты» (только у кого есть право настроек магазина; остальным —
 * просьба передать владельцу).
 */

import { Link } from "react-router";

import { legalProfileGapsText } from "./document-view";
import { useHasPermission } from "../../../auth/hooks";
import { Button } from "../../ui/button";
import { NoticeStrip } from "../../ui/NoticeStrip";

interface Props {
  /** База адресов магазина: `/shop/<slug>`. */
  base: string;
  /** Чего не хватает (коды сервера, можно с повторами из нескольких документов). */
  gaps: readonly string[];
  /** Документ уже выпущен с неполными реквизитами (текст про перевыпуск). */
  issued?: boolean;
}

export function LegalProfileNotice({ base, gaps, issued = false }: Props) {
  const canFix = useHasPermission("SHOP_MANAGE_SETTINGS");
  const missing = legalProfileGapsText(gaps);
  const consequence = issued
    ? "Документ выпущен с неполными реквизитами продавца."
    : "В документах реквизиты продавца выйдут неполными.";
  // Кнопка — под текстом, а не справа: на 360 справа она сжимала текст в столбик.
  return (
    <NoticeStrip tone="warning" title="Реквизиты продавца не заполнены">
      {missing ? <p className="font-medium">{missing}.</p> : null}
      <p>
        {consequence} {canFix ? null : "Попросите владельца магазина заполнить реквизиты в настройках."}
      </p>
      {canFix ? (
        <Button variant="outline" asChild className="mt-2">
          <Link to={`${base}/settings/legal-profiles`}>Заполнить реквизиты</Link>
        </Button>
      ) : null}
    </NoticeStrip>
  );
}
